
import type { DownloadCsvQuery, FetchResult, ResultWithData, StandardResult } from "./types";
import { makeFetchDataAndHeaders } from "./form_utils";
import { getCsrfToken } from "scripts/get_csrf_token";


/** get リクエストのテンプレート。 methodは書き換え可能。optionsの取得にも使える*/
export const fetchGetRequest = async ({
    endpoint,
    errorMessage,
    method = 'GET',
    params = {},
}) => {
    const queryParams = new URLSearchParams(params)
    const endpoint_with_param = queryParams ? `${endpoint}?${queryParams}` : endpoint

    const res: ResultWithData = await fetch(endpoint_with_param, { method: method }).then(async (result) => {
        if (result.ok) {
            const dataObj = await result.json();
            return { success: true, data: dataObj, error: [] };
        } else {
            return { success: false, data: undefined, error: [errorMessage] };
        }
    }).catch(error => {
        return {
            success: false,
            data: null,
            error: [`${errorMessage}\n ${error}`]
        }
    })
    return res;
}

type FetchArg = {
    endpoint: string,
    method: RequestMode,
    errorMessage: string,
    fetchObj?: Record<string, any>
}
// POST, PUTなどcsrftokenが必要なリクエストのテンプレート
export const fetchCustomRequest = async ({
    endpoint,
    method,
    fetchObj = undefined
}) => {
    const fetchData = makeFetchDataAndHeaders(fetchObj)
    // console.log(fetchData);

    const response: FetchResult = await fetch(endpoint, {
        method: method,
        mode: 'same-origin',
        headers: fetchData.headers,
        body: fetchData.body,
    }).then(async (result) => {
        if (result.ok) {
            const contentType = result.headers.get('content-type')
            // console.log(contentType);
            if (contentType == 'application/pdf') {
                const blob = await result.blob()
                return { success: blob }
            } else { // application/json
                const data = await result.json();
                return { success: data };
            }
        } else {
            const data = await result.json()
            return { error: data };
        }
    }).catch(error => {
        return {
            success: undefined,
            error: {
                common: [`エラーが発生したため、処理に失敗しました。\n ${error}`]
            }
        }
    });
    return response;
}

type FetchResultWithData = {
    success: boolean,
    message: string,
    result: any
}
/** fetch POST application/json 専用の簡易fetch 
 * error時のメッセージなどはサーバー側で付加する必要あり
*/
export const fetchPost = async ({
    endpoint,
    method,
    fetchObj = undefined
}) => {
    const fetchData = makeFetchDataAndHeaders(fetchObj)
    // console.log(fetchData);

    const response: FetchResultWithData = await fetch(endpoint, {
        method: method,
        mode: 'same-origin',
        headers: fetchData.headers,
        body: fetchData.body,
    }).then(async (result) => {
        return await result.json()
    }).catch(error => {
        return {
            success: false,
            result: null,
            message: `エラーが発生したため、処理に失敗しました。\n ${error}`
        }
    });
    return response;
}

/** 汎用のOptions取得function  */
export const getOptions = async (endpoint: string, params = {}) => {
    return await fetchGetRequest({
        endpoint: endpoint,
        errorMessage: 'Optionsを取得できませんでした。',
        method: 'OPTIONS',
        params: params
    })
}


export const fetch_download_csv = (query: DownloadCsvQuery) => {
    return fetch(`/product-manager/download-csv/`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": getCsrfToken(),
        },
        body: JSON.stringify(query),
    })
        .then((response) => response.blob())
        .then((blob) => {
            let anchor = document.createElement("a");
            anchor.download = "csv_file.zip";
            anchor.href = window.URL.createObjectURL(blob);
            anchor.click();
        });
}